// src/components/operationCenter/widgets/token/overview/TwPerformanceStripWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import PerformanceStrip from "@/components/tokenPage/overview/PerformanceStrip";

const TwPerformanceStripWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["fundamentals"]}>
        <PerformanceStrip livePrice={null} snapshotPrice={null} ws24hChangeDecimal={null} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwPerformanceStripWidget;
